import styled from 'styled-components';

export const CardContainer = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const InfoRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const Title = styled.span`
  font-weight: bold;
`;

export const Subtitle = styled(Title)`
  font-weight: 400;
`;
